// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvaibleMeals_meals__3Uuds","meals-appear":"AvaibleMeals_meals-appear__yD50s"};